export default "__VITE_ASSET__C08HfbbT__"